export const roundedTextFieldStyles = {
  borderRadius: "50px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px",
    backgroundColor: "#F1F7FA",
  },
  "& .MuiInputBase-input": {
    color: "#2A4876",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2A4876",
  },
};
